









import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import StaffEdit from "@/templates/StaffEdit.vue";
import SaveStaffRequest from "@/usecases/requests/save-staff-request";
import { Company, deleteStaff, getOurCompanies } from "@/api/company-api";
import { getServiceRoles } from "../../api/service-api";
import Role from "../../entities/role";
import TaskType from "@/entities/task-type";

@Component({
  components: {
    StaffEdit
  }
})
export default class OfficeStaffNewPage extends Vue {
  @Prop({ required: true }) companyId!: string;
  @Prop({ required: true }) id!: string;

  req = new SaveStaffRequest();
  companies: Company[] = [];
  roles: Role[] = [];
  errors: string[] = [];

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }

  ok() {
    this.save();
  }

  cancel() {
    this.goShowPage();
  }

  async remove() {
    this.destroy();
    this.goShowPage();
  }

  private async created() {
    this.$store.dispatch("tasktype/init");
    this.initServiceRoles();
    this.initCompanies();
    this.edit();
  }

  private async initCompanies() {
    this.companies = _.orderBy(await getOurCompanies(), "furigana", "asc");
  }

  private async initServiceRoles() {
    this.roles = await getServiceRoles();
  }

  @Watch("id")
  private async edit() {
    this.req = await this.$store.dispatch("editStaff", this.id);
  }

  private async save() {
    try {
      await this.$store.dispatch("saveStaff", this.req);
      this.goShowPage();
    } catch (e) {
      this.errors = e as [];
      return false;
    }
  }

  private async destroy() {
    await deleteStaff(this.id);
  }

  private goShowPage() {
    const params = { id: this.companyId };
    this.$router.push({ name: "office-show", params });
  }
}
